import { useContext } from "react"
import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { OkCancelContext } from "lib/@hooks/useDialog"

export function BasketLimitAlert({ itemType }) {
    const okCancel = useContext(OkCancelContext)
    const { ok } = okCancel

    return (
        <>
            <DialogTitle data-cy="basket-limit-alert-title">Unable to create new {itemType}</DialogTitle>
            <DialogContent data-cy={"basket-limit-alert"}>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body2">
                        You have reached the {itemType} limit, please remove an existing {itemType} before creating a
                        new one.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    data-cy="basket-limit-alert-ok-button"
                    onClick={() => ok(null)}
                    color="primary"
                    variant="contained"
                >
                    Ok
                </Button>
            </DialogActions>
        </>
    )
}
